type UploadcareConfig = {
  getUrl: (id: string, modifiers: string | null) => string;
  UcarecdnUrl: string;
};

export const uploadcareConfig: UploadcareConfig = {
  getUrl: (id, modifiers) => {
    return `${import.meta.env.VITE_UCARECDN_URL ?? ""}${id}/${
      modifiers ?? ""
    }-/quality/smart/-/format/auto/`;
  },
  UcarecdnUrl: import.meta.env.VITE_UCARECDN_URL,
};
